import { ChevronRight, CircleCheckBig, Dot, Shield } from "lucide-react";
import React from "react";

const ProductPreview = () => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-1 items-center">
        <span class="text-slate-500 text-xs uppercase tracking-[0.05em]">
          Next up
        </span>
        <ChevronRight size={13} color="#64748b" />
        <span class="text-slate-400 text-xs">Turn on load alerts</span>
      </div>

      <div className="bg-[#1A2332] rounded-2xl border !border-white/[0.08] overflow-hidden mb-2 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.5)]">
        <div className="bg-[#0F172A] px-3.5 py-2.5 flex items-center gap-2 border-b !border-white/[0.05]">
          <div class="w-2.5 h-2.5 rounded-full bg-red-500" />
          <div class="w-2.5 h-2.5 rounded-full bg-yellow-400" />
          <div class="w-2.5 h-2.5 rounded-full bg-green-500" />
        </div>
        <div className="p-4">
          <div className="bg-[#0F172A] rounded-[10px] p-3.5 mb-3 border !border-blue-500/[0.3]">
            <div className="flex justify-between items-start mb-2.5">
              <div className="flex flex-col gap-1">
                <span className="text-slate-200 text-[13px] font-semibold m-0">
                  Dallas, TX → Phoenix, AZ
                </span>
                <span className="text-slate-500 text-[11px] mt-1 mx-0 mb-0">
                  Dry Van • 42,000 lbs
                </span>
              </div>

              <span className="bg-green-500/15 text-green-500 text-[11px] font-semibold px-2 py-1 rounded-[6px]">
                94% Match
              </span>
            </div>

            <div className="flex justify-between pt-2.5 border-t border-white/[0.05]">
              <span class="text-blue-500 text-[15px] font-semibold">
                $2,450
              </span>
              <span class="text-slate-500 text-xs">$2.89/mi</span>
            </div>
          </div>

          <div className="bg-[#0F172A] rounded-[10px] p-3.5 opacity-50 flex justify-between items-start">
            <div className="flex flex-col gap-1">
              <span className="text-slate-200 text-[13px] font-semibold m-0">
                Houston, TX → Atlanta, GA
              </span>
              <span className="text-slate-500 text-[11px] mt-1 mx-0 mb-0">
                Reefer • 38,500 lbs
              </span>
            </div>

            <span className="bg-yellow-400/15 text-yellow-400 text-[11px] font-semibold px-2 py-1 rounded-[6px]">
              78% Match
            </span>
          </div>
        </div>
      </div>

      <div className="text-center text-slate-400 text-sm">
        <p>See lane-fit scores and rate per mile at a glance</p>
      </div>

      <div className="flex items-center justify-center gap-1 mb-1">
        <div className="flex items-center gap-1.5">
          <Shield size={14} color="#22c55e" />
          <span className="text-slate-500 text-xs">No spam</span>
        </div>
        <Dot color="#64748B" />
        <div className="flex items-center gap-1.5">
          <CircleCheckBig size={14} color="#3b82f6" />
          <span className="text-slate-500 text-xs">20+ dispatchers</span>
        </div>
      </div>

      <div className="flex items-center justify-center">
        <span className="text-slate-600 text-[11px] text-center m-0">
          ✓ Truckstop Marketplace Partner
        </span>
      </div>
    </div>
  );
};

export default ProductPreview;
